/** Converts `kebab-case` to `camelCase` */
export function kebabCaseToCamelCase(string: string) {
  return string.replace(/-./g, (x) => x.toUpperCase()[1])
}

/** Converts `camelCase` to `kebab-case` */
export function camelCaseToKebabCase(string: string) {
  return string.replace(/[A-Z]/g, (x) => `-${x.toLowerCase()}`)
}
